// Allow digits only, using a RegExp
export function onlyDigits (value: any) {
    return /^\d*$/.test(value);
}

export default function rangeMap(n: number, fn: (i: number) => any) {
    const arr = []
    while (n > arr.length) {
        arr.push(fn(arr.length))
    }
    return arr
}

export const formatSlug = ( slug: string ) =>
    slug
        .trim()
        .replace( /\s/g, '' )
        .replace( /_/g, '-' )
        .replace( /-+/g, '-' )
        .replace( /[^a-zA-Z0-9-]/g, '' )
        .toLowerCase();

export function generateUniqueId() {
    return Math.floor( Math.random() * Date.now() );
}

export function formatNumber(x:number) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export function validateEmail(input:string) {
    const validRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return !!input.match(validRegex);
}

export function getSimulatedBookingFlow (bookingFlow:string) {
    if(bookingFlow === 'hjulskifte-arval') {
        return 'hjulskifte';
    }else{
        return bookingFlow;
    }
}

export function getCookie(key:string) {
    var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
    return b ? b.pop() : "";
}
